import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSession } from 'shared/store/modules/auth/hooks';
import {
  selectAccessTokenExpirationDate,
} from 'shared/store/modules/auth/selectors';

import { useSelector } from 'react-redux';


export function useSessionTimer() {
  const { hasAccessToken, isRenewing, renewSession } = useSession();

  const accessTokenExpirationDate = useSelector(selectAccessTokenExpirationDate);

  const expirationDate = useMemo(() => {
    return moment(accessTokenExpirationDate).startOf('second');
  }, [accessTokenExpirationDate]);

  const calculateSessionTimeRemaining = useCallback(() => {
    return moment.duration(expirationDate.diff(moment(new Date()).startOf('second'))).asMilliseconds();
  }, [expirationDate]);

  const [sessionTimeRemaining, setSessionTimeRemaining] = useState(calculateSessionTimeRemaining);


  useEffect(() => {
    const interval = setInterval(() => {
      setSessionTimeRemaining(calculateSessionTimeRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateSessionTimeRemaining]);

  useEffect(() => {
    if (isRenewing) {
      return;
    }

    const shouldRenew = sessionTimeRemaining <= 0;

    if (shouldRenew || !hasAccessToken) {
      renewSession()
    }
  }, [hasAccessToken, sessionTimeRemaining, isRenewing, renewSession]);
}
